module.exports = __webpack_public_path__ + "/images/whatsapp-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/whatsapp-selected.svg
// module id = 626
// module chunks = 0